import { Dialog } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React, { FunctionComponent } from 'react';

type SiDialogProps = {
    open: boolean;
    onClose?: Function;
    isBackdropClick?: boolean;
    TransitionComponent?: React.JSXElementConstructor<TransitionProps & { children: React.ReactElement<any, any> }>;
};

const SiDialog: FunctionComponent<SiDialogProps> = ({
    open,
    onClose,
    isBackdropClick,
    TransitionComponent,
    children,
}) => (
    <Dialog
        open={open}
        onClose={(event, reason) => {
            if (!isBackdropClick && reason && reason === 'backdropClick') {
                return;
            }
            if (onClose) {
                onClose();
            }
        }}
        fullWidth
        className="MainDialog"
        sx={{ backdropFilter: 'blur(5px)' }}
        PaperProps={{ style: { borderRadius: '14px' } }}
        TransitionComponent={TransitionComponent}
    >
        {children}
    </Dialog>
);

export default SiDialog;
